module.exports = __webpack_public_path__ + "static/media/RHGrammar112819_posted.95afb6f5.pdf";